import type React from 'react';
import tinycolor from 'tinycolor2';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// Redux
import { selectLegibleElementColor } from 'reducers/config';
import { selectIsMobile } from 'reducers/main';
import { useAppSelector } from 'hooks';
// Assets
import AttachIcnImg from '../../assets/icons/attach-icon.svg';
import DeleteIcn from '../../assets/icons/remove-icon.svg';

interface AddFileFormProps {
  file: File;
  fileIndex: number;
  files: File[];
  setFiles: React.Dispatch<React.SetStateAction<File[] | null>>;
}

const FileItem = ({ file, fileIndex, files, setFiles }: AddFileFormProps) => {
  const isMobile = useAppSelector(selectIsMobile);
  const legibleElementColor = useAppSelector(selectLegibleElementColor);

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: tinycolor(legibleElementColor) + '14',
        borderRadius: '5px',
        color: legibleElementColor,
        display: 'flex',
        marginBottom: '5px',
        padding: '8px',
        position: 'relative',
      }}
    >
      <AttachIcon alt='attachIcon' src={AttachIcnImg} />
      <Box
        sx={{
          color: '#404b5a',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: `${isMobile ? 180 : 250}px`,
        }}
      >
        {file.name}
      </Box>
      <DeleteFileIcon
        aria-label={`Delete file ${file.name}`}
        onClick={() => {
          const newFiles =
            files &&
            files.filter((_: File, index: number) => fileIndex !== index);
          setFiles(newFiles);
        }}
        type='button'
      />
    </Box>
  );
};

const AttachIcon = styled('img')`
  margin-right: 10px;
`;

const DeleteFileIcon = styled('button')`
  position: absolute;
  cursor: pointer;
  right: 10px;
  width: 18px;
  height: 18px;
  background-image: url(${DeleteIcn});
  background-size: contain;
  border: none;
`;

export default FileItem;
